import Customer from "./customer/customer-list";
import CustomerEdit from './customer/customer-edit';
import CustomerView from './customer/customer-view';
import TenantEdit from './tenant/tenant-edit';
import Tenant from './tenant/tenant-list';
import UserEdit from './user_setting/user_access/user/user-edit';
import UserList from './user_setting/user_access/user/user-list';
import TenantView from './tenant/tenant-view';
import Menu from './system_config/menu_management/menu-list';
import AccessRight from './user_setting/user_access/access_right/access-right-list';
import AccessRightEdit from "./user_setting/user_access/access_right/access-right-edit";
import Module from "./system_config/module/module-list";
import ModuleEdit from "./system_config/module/module-edit";
import ModuleView from "./system_config/module/module-view";
import DeptList from "./system_config/department/dept-list";
import DeptEdit from "./system_config/department/dept-edit";
import DeptView from "./system_config/department/dept-view";
import ReferenceList from "./system_config/reference/reference-list";
import ReferenceEdit from "./system_config/reference/reference-edit";
import ParameterList from "./system_config/parameter/parameter-list";
import ParameterEdit from "./system_config/parameter/parameter-edit";
import ParameterView from "./system_config/parameter/parameter-view";
import PrefixnoList from "./system_config/prefix_no/prefixno-list";
import PrefixnoEdit from "./system_config/prefix_no/prefixno-edit";
import Profile from "./profile/profile";
import Bulletin from "./user_setting/office_automation/bulletin/bulletin-list";
import BulletinEdit from "./user_setting/office_automation/bulletin/bulletin-edit";

const adminRoutes = [
    { path: "/admin/customer", element: <Customer /> },
    { path: "/admin/customer-edit", element: <CustomerEdit /> },
    { path: "/admin/customer-view", element: <CustomerView /> },
    { path: "/admin/tenant", element: <Tenant /> },
    { path: "/admin/tenant-edit", element: <TenantEdit /> },
    { path: "/admin/tenant-view", element: <TenantView /> },
    { path: "/admin/user", element: <UserList /> },
    { path: "/admin/user-edit/", element: <UserEdit /> },
    { path: "/admin/menu", element: <Menu /> },
    { path: "/admin/access-right", element: <AccessRight /> },
    { path: "/admin/access-right-edit", element: <AccessRightEdit /> },
    { path: "/admin/module", element: <Module /> },
    { path: "/admin/module-edit", element: <ModuleEdit /> },
    { path: "/admin/module-view", element: <ModuleView /> },
    { path: "/admin/department", element: <DeptList /> },
    { path: "/admin/department-edit", element: <DeptEdit /> },
    { path: "/admin/department-view", element: <DeptView /> },
    { path: "/admin/reference", element: <ReferenceList /> },
    { path: "/admin/reference-edit", element: <ReferenceEdit /> },
    { path: "/admin/parameter", element: <ParameterList /> },
    { path: "/admin/parameter-edit", element: <ParameterEdit /> },
    { path: "/admin/parameter-view", element: <ParameterView /> },
    { path: "/admin/prefix-no", element: <PrefixnoList /> },
    { path: "/admin/prefix-no-edit", element: <PrefixnoEdit /> },
    { path: "/admin/profile", element: <Profile /> },
    { path: "/admin/bulletin", element: <Bulletin /> },
    { path: "/admin/bulletin-edit", element: <BulletinEdit /> }
];

export default adminRoutes;
